import { mergeDeepRight } from 'ramda'

import { types as CareTypes } from 'store/Care'
import { initialState } from './index'

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    // for now we're going to be just listening to the
    // various actions that correspond with getting
    // the filter options.
    case CareTypes.FETCH_CARE_FILTERS_SUCCESS:
    case CareTypes.FETCH_PUBLIC_CARE_FILTERS_SUCCESS: {
      // we're going to do some transposing of the options
      // because the names we get in the payload are terrible.
      return {
        ...state,
        filterOptions: mergeDeepRight(state.filterOptions, {
          // careTypes: payload.careType,
          careLocations: payload.locations.map(loc => ({
            label: loc.label,
            value: loc.uuid,
          })),
        }),
      }
    }

    default:
      return state
  }
}
